import {createGate} from 'effector-react';

import {fetchOrderCreate, fetchGtinInfo} from 'api/orders';
import {rootDomain} from 'core/rootDomain';
import {OrderFormData, OrderProductsData} from 'types';

const domain = rootDomain.createDomain('OrdersListDomain');
export const OrdersCreateGate = createGate('OrdersCreateGate');

export const sendOrderFx = domain.createEffect({
    name: 'fetchOrderListFx',
    handler: fetchOrderCreate,
});

export const getGtinInfoFx = domain.createEffect({
    name: 'fetchGtinInfoFx',
    handler: fetchGtinInfo,
});

export const createOrder = domain.createEvent();

export const firstStep$ = domain.createStore<OrderFormData>({
    country: '',
    factoryId: '',
    factoryName: '',
    productionLineId: '',
    productionLineName: '',
    productGroupCode: '',
});
export const firstStepChanged = domain.createEvent<OrderFormData>();

export const step$ = domain.createStore<number>(0);
export const stepChanged = domain.createEvent<number>();

export const fileChanged = domain.createEvent<File | undefined | null>();
export const file$ = domain.createStore<File | undefined | null>(null);

export const products$ = domain.createStore<Array<OrderProductsData>>([]);
export const productsChanged = domain.createEvent<Array<OrderProductsData>>();

export const productGroup$ = domain.createStore<string | null>('ALCOHOL');
export const productGroupChanged = domain.createEvent<string | null>();

export const fetchGtinInfoEvent = domain.createEvent();
